<div [hidden]="!active">
    <ng-content />
</div>
